const experience = [
  {
    id: 1,
    role: "FrontEnd Engineer",
    company: "Accenture, Bengaluru",
    duration: "March 2022 - present",
    objective:
      "Enhancements on the existing customer-facing mobile application of a leading Asian Banking and Financial Services company using React Native",
    techStack: ["ReactJS", "Redux", "React Native", "Xcode", "Android Studio"],
    iconClass: "react",
    modalContent: {
      leftContent: {
        title: "FrontEnd Engineer",
        description: (
          <p>
            Enhancements on existing customer-facing mobile application as well
            as buidling internal Admin Portal for a leading Asian Banking and
            Financial Services company.
            <br />
            <strong>Worked on:</strong> ReactJS, Redux, React Native, Xcode,
            Android Studio
            <br />
            <br />
            <strong>Company:</strong> Accenture, Bengaluru
            <br />
            <strong>Duration:</strong> March 2022 - present
          </p>
        ),
      },
      rightContent: {
        title: "Roles and Responsibilities",
        description: (
          <ul>
            <li>
              Designed and implemented responsive Admin Portal interfaces with
              ReactJS and Redux to improve internal workflows.
            </li>
            <li>
              Led the optimization of a Mobile Banking app for a major Malaysian
              bank, enhancing cross-platform performance using React Native.
            </li>
            <li>
              Owned end-to-end delivery for key sub-projects, ensuring timely
              and quality results.
            </li>
            <li>
              Contributed to peer code reviews, promoting best practices and
              high code quality.
            </li>
          </ul>
        ),
      },
    },
  },
  {
    id: 2,
    role: "Full-Stack Developer",
    company: "Tata Consultancy Services, Kochi",
    duration: "July 2019 - February 2022",
    objective:
      "Rebuild of multiple websites of a leading multinational pharmaceutical and life sciences company using Acquia Drupal Platform.",
    techStack: ["Drupal 8", "PHP", "SASS", "jQuery"],
    iconClass: "drupal",
    modalContent: {
      leftContent: {
        title: "Full-Stack Developer",
        description: (
          <p>
            Rebuild of multiple websites of a leading multinational
            pharmaceutical and life sciences company using Acquia Drupal
            Platform.
            <br />
            <strong>Worked on:</strong> Drupal 8, PHP, SASS, jQuery
            <br />
            <br />
            <strong>Company:</strong> Tata Consultancy Services, Kochi
            <br />
            <strong>Duration:</strong> July 2019 - February 2022
          </p>
        ),
      },
      rightContent: {
        title: "Roles and Responsibilities",
        description: (
          <ul>
            <li>
              Led the rebuild of corporate websites for a global pharmaceutical
              client using Acquia Drupal, improving performance and scalability.
            </li>
            <li>
              Developed backend solutions with Drupal 8 and PHP, and contributed
              to frontend development with SASS and jQuery.
            </li>
            <li>
              Managed end-to-end delivery for sub-projects, ensuring alignment
              with client expectations.
            </li>
            <li>
              Supported effort estimations and RFPs, contributing to business
              development efforts.
            </li>
            <li>
              Conducted peer code reviews and ensured effective codebase
              management within the Platform Team.
            </li>
            <li>
              Served as L&D SPOC, organizing training sessions to upskill the
              team.
            </li>
          </ul>
        ),
      },
    },
  },
  {
    id: 3,
    role: "Frontend Developer",
    company: "Tata Consultancy Services, Kochi",
    duration: "July 2018 - June 2019",
    objective:
      "Building responsive user interface to be used in the Catering Management System for a leading airline service.",
    techStack: ["ReactJS", "Redux", "SASS"],
    iconClass: "react",
    modalContent: {
      leftContent: {
        title: "Frontend Developer",
        description: (
          <p>
            Building responsive user interface to be used in the Catering
            Management System for a leading airline service.
            <br />
            <strong>Worked on:</strong> ReactJS, Redux, SASS
            <br />
            <br />
            <strong>Company:</strong> Tata Consultancy Services, Kochi
            <br />
            <strong>Duration:</strong> July 2018 - March 2019
          </p>
        ),
      },
      rightContent: {
        title: "Roles and Responsibilities",
        description: (
          <ul>
            <li>
              Developed a responsive user interface for the Catering Management
              System of a leading airline.
            </li>
            <li>
              Conducted unit testing to ensure deliverable quality and
              functionality.
            </li>
            <li>
              Delivered progress reports to stakeholders and maintained
              consistent client engagement to refine requirements.
            </li>
            <li>
              Maintained consistent client communication to refine project
              requirements.
            </li>
          </ul>
        ),
      },
    },
  },
];

export default experience;
